import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Industries from './components/Industries';
import HowItWorks from './components/HowItWorks';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/252ba0c726fdd5d02f883c440da24bd7/21e8579bce648dd00e21a709fde6a40a.jpeg" 
                alt="TechHeroesHub Logo" 
                className="h-16 w-auto object-contain"
                style={{ mixBlendMode: 'multiply' }}
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-[#ffbd59] ${scrolled ? 'text-gray-800' : 'text-white'}`}>Home</button>
              <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-[#ffbd59] ${scrolled ? 'text-gray-800' : 'text-white'}`}>Services</button>
              <button onClick={() => scrollToSection('why-choose-us')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-[#ffbd59] ${scrolled ? 'text-gray-800' : 'text-white'}`}>Why Choose Us</button>
              <button onClick={() => scrollToSection('industries')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-[#ffbd59] ${scrolled ? 'text-gray-800' : 'text-white'}`}>Industries</button>
              <button onClick={() => scrollToSection('how-it-works')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-[#ffbd59] ${scrolled ? 'text-gray-800' : 'text-white'}`}>How It Works</button>
              <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer hover:text-[#ffbd59] ${scrolled ? 'text-gray-800' : 'text-white'}`}>Contact</button>
            </div>
          </div>
        </div>
      </nav>

      <Hero />
      <Services />
      <WhyChooseUs />
      <Industries />
      <HowItWorks />
      <Contact />
      <Footer />
    </div>
  );
}